// App Types
export const APP_CHECK_VIEW_PORT = 'APP_CHECK_VIEW_PORT';
export const LOAD_FORM_STATE     = 'LOAD_FORM_STATE';
export const FORM_STATE_LOADED   = 'FORM_STATE_LOADED';
export const APP_LOAD_FAILED     = 'APP_LOAD_FAILED';

export const SAVE_APPSTATE_REQUEST = 'SAVE_APPSTATE_REQUEST';
export const SAVE_APPSTATE_SUCCESS = 'SAVE_APPSTATE_SUCCESS';
export const SAVE_APPSTATE_FAILURE = 'SAVE_APPSTATE_FAILURE';

// Form Types
export const STORE_FORM_REQUEST = 'STORE_FORM_REQUEST';
export const STORE_FORM_SUCCESS = 'STORE_FORM_SUCCESS';
export const STORE_FORM_FAILURE = 'STORE_FORM_FAILURE';

// Upload Types
export const UPLOAD_FILE_REQUEST    = 'UPLOAD_FILE_REQUEST';
export const UPLOAD_FILE_DELETE     = 'UPLOAD_FILE_DELETE';
export const UPLOAD_FILE_UPLOADING  = 'UPLOAD_FILE_UPLOADING';
export const UPLOAD_FILE_SUCCESS    = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAILURE    = 'UPLOAD_FILE_FAILURE';

export const UPDATE_ADDRESS         = 'UPDATE_ADDRESS';
export const LOAD_SERVICE_STATE     = 'LOAD_SERVICE_STATE';

// Get Quote
export const GET_QUOTE_REQUEST = 'GET_QUOTE_REQUEST';
export const GET_QUOTE_SUCCESS = 'GET_QUOTE_SUCCESS';
export const GET_QUOTE_FAILURE = 'GET_QUOTE_FAILURE';

// Check Mapshare data
export const CHECK_MAPSHARE_REQUEST = 'CHECK_MAPSHARE_REQUEST';
export const CHECK_MAPSHARE_SUCCESS = 'CHECK_MAPSHARE_SUCCESS';
export const CHECK_MAPSHARE_FAILURE = 'CHECK_MAPSHARE_FAILURE';